import { Button, Grid } from '@mui/material'

import { useEditConfig } from '@providers/EditConfigProvider'

import { buttonStylesByMode } from '@helpers'
import { CONFIG_MENU_OPTION } from '@constants'

export const ExportActionsPanel = () => {
  const {
    configMenuOption,
    handleExportConfigs,
    handleCancel,
    selectedConfigId,
    isExportAllSelected,
    isConfigMenuLoading,
  } = useEditConfig()

  if (!configMenuOption || configMenuOption === CONFIG_MENU_OPTION.IMPORT) return null

  return (
    <Grid
      container
      justifyContent='flex-end'
      sx={{
        mt: 2,
        gap: 2,
        px: 1,
      }}
    >
      <Button
        sx={theme => ({
          ...buttonStylesByMode(theme),
        })}
        onClick={handleCancel}
      >
        Cancel
      </Button>
      <Button
        disabled={(!selectedConfigId && !isExportAllSelected) || isConfigMenuLoading}
        sx={theme => ({
          ...buttonStylesByMode(theme),
        })}
        onClick={() => handleExportConfigs()}
      >
        {configMenuOption}
      </Button>
    </Grid>
  )
}
